import { Stack } from "@altimateai/lego";
import { Switch, Label } from "@altimateai/lego";

interface ProjectLocationSwitchProps {
  useCustomLocation: boolean;
  onToggle: (checked: boolean) => void;
  isDisabled: boolean;
  mustUseCustomLocation: boolean;
  subprojectName: string;
  /** True when the connecting PAT role can publish workbooks. When false
   * (Explorer), the helper text changes from "where to create" to "where to
   * locate" since we cannot publish. */
  canPublishWorkbooks?: boolean;
}

export const ProjectLocationSwitch = ({
  useCustomLocation,
  onToggle,
  isDisabled,
  mustUseCustomLocation,
  subprojectName,
  canPublishWorkbooks = true,
}: ProjectLocationSwitchProps) => {
  let helperText: string;
  if (mustUseCustomLocation) {
    helperText = canPublishWorkbooks
      ? "Required: Default location is already in use"
      : "Required: We couldn't auto-detect your Altimate workbooks under the Default project";
  } else {
    helperText = canPublishWorkbooks
      ? `Browse and select a project where the "${subprojectName}" subproject will be created`
      : "Browse and select the parent project where you uploaded the Altimate workbooks";
  }
  return (
    <Stack
      direction="row"
      align="center"
      gap="md"
      className="al-mb-4 al-p-3 al-bg-gray-50 al-rounded-md al-border"
    >
      <Switch
        id="custom-location"
        checked={useCustomLocation}
        onCheckedChange={onToggle}
        disabled={isDisabled}
      />
      <Label
        htmlFor="custom-location"
        className={`al-flex-1 al-cursor-pointer ${isDisabled ? "al-text-gray-500" : ""}`}
      >
        <div className="al-font-medium">Use custom project location</div>
        <div className="al-text-xs al-text-gray-600 al-mt-1">{helperText}</div>
      </Label>
    </Stack>
  );
};
